import React, {createContext, useContext, useState, useRef} from "react";

const DownloadFileProgressContext = createContext();


export const DownloadProgressProvider = ({ children }) => {
    const downloadControllerRef = useRef({});

    const [downloads, setDownloads] = useState([]);
    const [completedDownloads, setCompletedDownloads] = useState([]);
    const [cancelledDownloads, setCancelledDownloads] = useState([]);

    const startDownload = (id, fileName) => {
        const controller = new AbortController();
        const downloadId = `${id}-${Date.now()}`;
        downloadControllerRef.current[downloadId] = controller;


        setDownloads(prev => [...prev, { id: downloadId, fileName, progress: 0, error: false }]);
        return {downloadId: downloadId, downloadSignal: controller.signal};
    };

    const batchStartDownload = (files) => {
        const downloadInfo = files.map(file => {
            const download_id = `${file.id}-${Date.now()}`; 
            setDownloads(prev => [...prev, { id: download_id, fileName: file.fileName, progress: 0, error: false }]);
            return {download_id: download_id, file: file};
        });
        return downloadInfo;
    }
    const updateProgress = (id, progress) => {
        setDownloads(prev => prev.map(d => d.id === id ? { ...d, progress } : d));
        if (progress === 100) {
            setCompletedDownloads(prev => [...prev, id]);
        }
    };

    const removeDownload = (id) => {
        setDownloads(prev => prev.filter(d => d.id !== id));
        setCompletedDownloads(prev => prev.filter(d => d !== id));
    };

    const clearDownloads = () => {
        setDownloads([]);
        setCompletedDownloads([]);
        setCancelledDownloads([]);
    }

    const updateErrorDownloads = (id) => {
        setDownloads(prev => prev.map(d => d.id === id ? { ...d, error: true} : d));
        setCompletedDownloads(prev => [...prev, id]);
    }

    const cancelDownload = (id) => {
        setDownloads(prev => prev.filter(d => d.id !== id));
        setCompletedDownloads(prev => prev.filter(d => d !== id));
        setCancelledDownloads(prev => [...prev, id]);
        downloadControllerRef.current[id]?.abort();
    }
    return(
        <DownloadFileProgressContext.Provider value={{ downloads, clearDownloads, startDownload, batchStartDownload, updateProgress, removeDownload, completedDownloads, updateErrorDownloads, cancelDownload }}>
            {children}
        </DownloadFileProgressContext.Provider>
    )
}

export const useDownloadFileProgress = () => useContext(DownloadFileProgressContext);
